<router-outlet />

@if (isLoading) {
  <splash-screen></splash-screen>
}